export default __webpack_public_path__ + "static/media/cntr-tracking-rq-dark.7ba7b8f8.svg";